import { STARTER } from 'self-service-api/constants/ProductLevels';
import { BUY_TOUCHLESS, TALK_TO_SALES, TRIAL } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { suitePurchaseMotionsMapSelector } from '../../../selectors/PurchaseMotionSelectors';
import { useFTS0011Experiment } from '../../../utils/experiments/fts0011';
export const useSuitePurchaseMotions = ({
  productLevel,
  returnFirstCTAOnly
}) => {
  const isAppReady = useGlobalLoading();
  const suitePurchaseMotions = useAppSelector(state => {
    if (!isAppReady) return [];
    const purchaseMotionsMap = suitePurchaseMotionsMapSelector(state);
    return (purchaseMotionsMap === null || purchaseMotionsMap === void 0 ? void 0 : purchaseMotionsMap[productLevel]) || [];
  });
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const {
    isFTS0011Variant
  } = useFTS0011Experiment();
  if (isAppAuth) {
    return returnFirstCTAOnly && suitePurchaseMotions.length ? [suitePurchaseMotions[0]] : suitePurchaseMotions;
  }
  if (isFTS0011Variant && productLevel === STARTER && suitePurchaseMotions.includes(BUY_TOUCHLESS)) {
    if (returnFirstCTAOnly) {
      return [BUY_TOUCHLESS];
    }
    return [TRIAL, BUY_TOUCHLESS];
  }
  // public purchase motions are always 1 button unless trial exist in the array, then show all the buttons
  if (suitePurchaseMotions.includes(TRIAL)) return suitePurchaseMotions;
  if (suitePurchaseMotions.includes(BUY_TOUCHLESS)) return [BUY_TOUCHLESS];
  return [TALK_TO_SALES];
};
export default useSuitePurchaseMotions;